<template lang="html">

    <div class="politica-de-cookies">
  
      <section class="intro-legales column-center launch">
  
        <h1 class="subtitle-intro">
          <span>{{$t("intros_legales.politica_cookies")}}</span>
        </h1>
  
      </section> 
  
      <section class="textos-legales container">
  
       <h2>Что такое файлы cookie и для чего мы их используем?</h2>
       <p>Файл cookie или компьютерный файл cookie — это небольшой информационный файл, который сохраняется в вашем браузере каждый раз, когда вы посещаете наш веб-сайт.</p>
       <p>Целью файлов cookie является сохранение истории вашей активности на нашем веб-сайте, чтобы при повторном посещении он мог идентифицировать вас и настроить свой контент на основе ваших привычек просмотра, особенностей личности и предпочтений.</p>
       <p>Файл cookie безвреден, он не содержит вредоносного или вредоносного кода (например, вирусов, троянов, червей и т. д.), который может повредить ваш терминал (компьютер, смартфон, планшет и т. д.), но оказывает определенное влияние на ваше право для защиты ваших данных, поскольку он собирает определенную информацию о вас (привычки просмотра, личность, предпочтения и т. д.).</p>
  
       <h2>Какую информацию хранит файл cookie?</h2>
       <p>Файлы cookie обычно не собирают специальные категории персональных данных (конфиденциальные данные). Сохраняемые ими данные имеют технический характер, личные предпочтения, настройку контента и т. д.</p>
  
       <h2>Какие типы файлов cookie существуют?</h2>
       <p>В целом существует пять типов файлов cookie:</p>
       <p>Технические файлы cookie:</p>
       <p>Это самые основные файлы cookie. Они позволяют пользователю перемещаться по веб-странице, платформе или приложению, а также использовать различные опции или услуги, которые существуют на нем, такие как управление трафиком и передачей данных, идентификация сеанса, доступ к частям с ограниченным входом, запоминание элементов, которые позволяют оформлять заказ, осуществлять процесс покупки, подавать заявку на регистрацию или участие в мероприятии, использовать элементы безопасности при просмотре, сохранять контент для видео- или звуковой трансляции или делиться контентом через социальные сети.</p> 
  
       <h2>Файлы cookie для персонализации: </h2>
       <p>Это те, которые позволяют пользователю получить доступ к услуге с некоторыми предопределенными общими характеристиками на основе ряда критериев в пользовательском терминале, таких как язык, тип браузера, через который осуществляется доступ к услуге, региональная конфигурация, откуда вы получаете доступ сервис и т.д.</p>
  
       <h2>Аналитические файлы cookie:</h2>
  
       <h2>Рекламные файлы cookie:</h2>
       <p>Это те, которые позволяют максимально эффективно управлять рекламными площадями, которые, при необходимости, ответственное лицо включило в веб-страницу, приложение или платформу, с которых предоставляется запрошенная услуга, на основе таких критериев, как отредактированное содержание или частота показа рекламы.</p>
  
       <h2>Поведенческие рекламные файлы cookie:</h2>
       <p>Это те, которые позволяют максимально эффективно управлять рекламными площадями, которые, при необходимости, ответственное лицо включило в веб-страницу, приложение или платформу, с которой предоставляется запрошенная услуга. Эти файлы cookie хранят информацию о поведении пользователей, полученную в результате постоянного наблюдения за их привычками просмотра, что позволяет разработать конкретный профиль для отображения рекламы на его основе.</p>
  
       <h2>Что такое собственные и сторонние файлы cookie?</h2>
       <p>Собственные файлы cookie:</p>
       <p>Собственные файлы cookie — это те, которые создаются и управляются лицом, ответственным за предоставление услуги, запрошенной пользователем.</p>
  
       <h2><strong> Сторонние файлы cookie:</strong></h2>
       <p>Это те, которые генерируются организациями, отличными от ответственного лица (услугами или внешними поставщиками, такими как Google).</p>
  
       <h2>Какие типы файлов cookie хранит наш веб-сайт?</h2>
      <p>Далее мы переходим к перечислению типов файлов cookie, которые хранит наш веб-сайт, и их назначению:</p>
      <p>- Тип файла cookie</p>
      <p>Сторонние файлы cookie, анализ: Google Analytics</p>
      <p>- Цель</p>
      <p>Мониторинг и анализ поведения пользователей на сайте. Информация, собранная с помощью файлов cookie этого типа, используется для измерения активности веб-сайтов, для разработки навигационных профилей пользователей указанных сайтов, приложений и платформ, чтобы вносить улучшения на основе анализа данных об использовании, сделанных пользователей сервиса.</p>
      <p>- Когда и как хранить</p>
      <p>Файл cookie записывает действия пользователя в режиме реального времени во время просмотра, а данные сохраняются в приложении «Google Analytics».</p>
  
  
      <h2>Что я могу сделать с файлами cookie?</h2>
      <p>Файлы cookie могут быть удалены, приняты или заблокированы по вашему желанию, для этого вам нужно только удобно настроить веб-браузер.</p>
      <p>В любое время вы можете запретить установку (блокировку) файлов cookie на свой компьютер с помощью соответствующей опции в своем браузере, но в этом случае мы не можем обеспечить правильное функционирование различных функций нашего веб-сайта.</p>
      <p>Далее мы предоставляем вам ссылки для управления и блокировки файлов cookie в зависимости от используемого вами браузера:</p>
      <p><strong>Internet Explorer:</strong> <a target="_blank" href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10">http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-10</a></p>
      <p><strong>FireFox:</strong> <a target="_blank" href= "http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></p>
      <p><strong>Chrome:</strong> <a target="_blank" href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></p>
      <p><strong>Safari:</strong> <a target="_blank" href="https://www.apple.com/legal/privacy/es/cookies/">https://www.apple.com/legal/privacy/es/cookies/</a></p>
  
      <p>Вы также можете удалить файлы cookie, которые вы сохранили в своем браузере, перейдя в параметры его конфигурации.</p>
  
  
      </section>
  
    </div>
  
  </template>
  
  <script lang="js">
    export default  {
      name: 'politica-de-cookies',
    }
  </script>
  
  


// WEBPACK FOOTER //
// src/components/views/politica-de-cookies-ru.vue